import { render, staticRenderFns } from "./PriceSearch.vue?vue&type=template&id=34c70264&"
import script from "./PriceSearch.vue?vue&type=script&lang=js&"
export * from "./PriceSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports